// 暂停页面全部video/audio
export const pauseVideoAudio = () => {
  // 暂停播放video/audio
  // 获取页面上所有的video/audio对象
  const allVideoElement = document.getElementsByTagName('video')
  const allAudioElement = document.getElementsByTagName('audio')
  if (allVideoElement && allVideoElement.length > 0) {
    for (let i = 0; i < allVideoElement.length; i++) {
      allVideoElement[i]!.pause()
    }
  }
  if (allAudioElement && allAudioElement.length > 0) {
    for (let i = 0; i < allAudioElement.length; i++) {
      allAudioElement[i]!.pause()
    }
  }
}
